import { action } from 'typesafe-actions';

import { ISearchActionTypes, IMedia, IProgramType, IProgramEditor, IAutocompletePerson, IPoliticalGroupSpecific, ITimeFilters, ISearchFilters } from './Types';

export const getMediasTDP = (token: string) => {
    return action(ISearchActionTypes.GET_MEDIAS_TDP, token)
};
export const getMediasTDPSuccess = (mediasTDP: IMedia[]) => {
    return action(ISearchActionTypes.GET_MEDIAS_TDP_SUCCESS, mediasTDP)
}
export const getMediasTDPError = (error: string) => {
    return action(ISearchActionTypes.GET_MEDIAS_TDP_ERROR, error)
}
export const getProgramTypes = (token: string) => {
    return action(ISearchActionTypes.GET_PROGRAM_TYPES, token)
};
export const getProgramTypesSuccess = (programTypes: IProgramType[]) => {
    return action(ISearchActionTypes.GET_PROGRAM_TYPES_SUCCESS, programTypes)
}
export const getElectionCampaign = () => {
    return action(ISearchActionTypes.GET_ELECTION_CAMPAIGN, [])
}
export const getProgramTypesError = (error: string) => {
    return action(ISearchActionTypes.GET_PROGRAM_TYPES_ERROR, error)
}
export const getProgramEditors = (token: string) => {
    return action(ISearchActionTypes.GET_PROGRAM_EDITORS, token)
};
export const getProgramEditorsSuccess = (programEditors: IProgramEditor[]) => {
    return action(ISearchActionTypes.GET_PROGRAM_EDITORS_SUCCESS, programEditors)
}
export const getProgramEditorsError = (error: string) => {
    return action(ISearchActionTypes.GET_PROGRAM_EDITORS_ERROR, error)
}
export const getAutocompletePerson = (person_name: string) => action(ISearchActionTypes.GET_AUTOCOMPLETE_PERSON, person_name)
export const getAutocompletePersonSuccess = (personsList: IAutocompletePerson[]) => action(ISearchActionTypes.GET_AUTOCOMPLETE_PERSON_SUCCESS, personsList)

export const getMediasSource = (mediaIds: number[]) => action(ISearchActionTypes.GET_MEDIAS_SOURCE, mediaIds)
export const getMediasSourceSuccess = (mediasSource: any) => action(ISearchActionTypes.GET_MEDIAS_SOURCE_SUCCESS, mediasSource)

export const getPoliticalGroupSpecific = (year: number) => action(ISearchActionTypes.GET_POLITICAL_GROUP_SPECIFIC, year)
export const getPoliticalGroupSpecificSuccess = (results: IPoliticalGroupSpecific[]) => action(ISearchActionTypes.GET_POLITICAL_GROUP_SPECIFIC_SUCCESS, results)

export const clearPersonsList = () => action(ISearchActionTypes.CLEAR_PERSONS_LIST, [])
export const resetSearchData = () => action(ISearchActionTypes.RESET_DATA, [])

export const saveFilters = (filters: ISearchFilters) => action(ISearchActionTypes.SAVE_FILTERS, filters)
export const resetFilters = () => action(ISearchActionTypes.RESET_FILTERS, [])
export const saveTimeFilters = (filters: ITimeFilters) => action(ISearchActionTypes.SAVE_TIME_SELECTION, filters)
